import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HeaderComponent, FooterComponent, ButtonComponent } from 'app/shared/components';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, ButtonComponent],
  templateUrl: './error-page.html',
})
export class ErrorPageComponent {
  private readonly router = inject(Router);
  
  title: string;
  description: string;
  showHomeButton: boolean;

  constructor() {
    const state = window.history.state;

    this.title = state?.title ?? '¡Ups! No se encuentra esta página';
    this.description = state?.description ?? 'Es posible que se haya eliminado la página que buscas';
    this.showHomeButton = state?.showHomeButton ?? true;
  }

  goToHome() {
    this.router.navigate(['/home']);
  }
}